import { useAppContext } from "./AppContext";
import './PageLoadingSpinner.scss';

export const PageLoadingSpinner = () => {
    const { loading } = useAppContext();

    if (!loading) return null;

    return (
        <div id="appSpinner" className="d-flex justify-content-center align-items-center" style={{
            height: '100vh', position: 'fixed', top: 0,
            flexDirection: 'column',
            left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0, 0, 0, 0.2)', zIndex: 1100
        }}>
            <div className="loading-text">
                <span className="letter">B</span>
                <span className="letter">e</span>
                <span className="letter">a</span>
                <span className="letter">u</span>
                <span className="letter">t</span>
                <span className="letter">y</span>
                <span className="letter"> </span>
                <span className="letter">T</span>
                <span className="letter">r</span>
                <span className="letter">e</span>
                <span className="letter">a</span>
                <span className="letter">s</span>
                <span className="letter">u</span>
                <span className="letter">r</span>
                <span className="letter">e</span>
                <span className="letter">s</span>
            </div>
            <div className="loader"></div>
        </div>
    );
};